/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import { testIdConcat } from '@jira/navigation-apps__common/src/utils/test-id.tsx';
import SkeletonItem from '@atlaskit/menu/skeleton-item';
import type { MenuSkeletonFooterProps } from './types.tsx';

export const MenuSkeletonFooter = ({
	testIdPrefix,
	numItems = 2,
}: MenuSkeletonFooterProps): React.JSX.Element => (
	<div data-testid={testIdConcat(testIdPrefix, 'skeleton')}>
		<SkeletonItem width="50%" />
		{numItems >= 2 && <SkeletonItem width="50%" />}
	</div>
);
